import React from 'react'
import { Possession } from '../../types/types';

const { REACT_APP_BRAND } = process.env;

interface RoleProps {
  possession?: Possession;
  onClick: (possession: Possession) => void;
}

const Role = (props: RoleProps) => {
  const { possession, onClick } = props;
  const { title1, typeTitle, title2 } = possession || {};

  const handleClick = () => {
    onClick(possession || {} as Possession);
  }
  return (
    <tr>
      <td>
        <span className={`role-type ${REACT_APP_BRAND === 'CITY' ? 'cityhaftet' : ''}`}>{typeTitle}</span>
        <span className="role-title">{title1}</span>
        {title2 !== ''
          && <span className="role-sub-title">{title2}</span>}
      </td>
      <td>
        <button className="primary md alt handle" type="button" onClick={handleClick}>Hantera</button>
      </td>
    </tr>
  );
}

export default Role
